import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const TableTextCell = styled(Typography.TextBody_16_24)<{
    flex: number;
    isMain?: boolean;
    maxWidth?: number;
    minWidth?: number;
}>(
    ({ flex, isMain, maxWidth, minWidth, theme: { fontSize, palette } }) => css`
        align-items: center;
        color: ${isMain ? palette.tertiary.default : palette.text.primary};
        flex-wrap: wrap;
        flex: ${flex};
        max-width: ${maxWidth ? `${maxWidth}px` : '100%'};
        overflow: hidden;
        padding-right: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${minWidth &&
        css`
            min-width: ${minWidth}px;
        `}

        @media (max-width: ${breakpoints.md}px) {
            font-size: ${fontSize[14]}px;
            line-height: 24px;

            &:last-of-type {
                padding-right: 0;
            }
        }
    `,
);

export const TableRow = styled.li<{ isClickable?: boolean }>(
    ({ isClickable, theme: { boxShadow, palette, radius } }) => css`
        align-items: center;
        background: ${palette.neutral.white};
        border-radius: ${radius[4]}px;
        box-shadow: ${boxShadow.small};
        display: flex;
        justify-content: space-between;
        padding: 22px 16px 18px;
        position: relative;
        ${isClickable && 'cursor: pointer'};

        &:hover {
            box-shadow: ${boxShadow.big};
            z-index: 9;
        }

        @media (max-width: ${breakpoints.md}px) {
            padding: 18px 18px 14px 20px;
        }

        @media (max-width: ${breakpoints.xs}px) {
            ${TableTextCell}:first-child {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 200px;
            }
        }

        @media (max-width: ${breakpoints.xxs}px) {
            ${TableTextCell}:first-child {
                width: 150px;
            }
        }
    `,
);
